import { render, staticRenderFns } from "./UserFamilyChildrenEdit.vue?vue&type=template&id=e2e9dfa8&"
import script from "./UserFamilyChildrenEdit.vue?vue&type=script&lang=js&"
export * from "./UserFamilyChildrenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports